import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment.prod';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class SobreService {

  constructor(
    private http: HttpClient
  ) { }

  getSobre() {
    const url = `${environment.API}sobre`;
    return this.http.get(url);
  }

  getPortifolio() {
    const url = `${environment.API}portifolio`;
    return this.http.get(url);
  }
}


